import { getRenderer } from "csi/components/index";
import React, { createContext, FunctionComponent, useContext } from "react";
import { IFormField } from "src/c8-platform/type/form";
import { C8NodeType } from "src/c8-platform/type/node";
import { cnl } from "src/c8-platform/type/value";

export interface StatefulFormFieldProps {
	field: IFormField;
	nodeType: C8NodeType;
	nodeUrl?: cnl;
	reportOperations?: string;
}

export const StatefulFormField: FunctionComponent<StatefulFormFieldProps> = ({ field, nodeType, nodeUrl, reportOperations }) => {
	const { attributeId, transientInfo: { hidden }, valueType } = field;

	// TODO: hidden should be handled by the renderer, and will be done later
	// if (hidden) {
	// 	return null;
	// }

	const RendererComponent = getRenderer(valueType);

	if (!RendererComponent) {
		return null;
	}

	const rendererProps = {
		attributeId,
		nodeType,
		nodeUrl,
		reportOperations,
	};

	// wrap the renderer component with provider of field
	return (
		<StatefulFormFieldContext.Provider value={field}>
			<RendererComponent
				{...rendererProps}
			/>
		</StatefulFormFieldContext.Provider>
	);
};

export const StatefulFormFieldContext = createContext<IFormField>(null);
export const useStatefulFormField = (): IFormField => useContext(StatefulFormFieldContext);